@if (templates().length) {
  <select #select class="big" (input)="templateChange.emit(select.value)">
    <option value="" [selected]="!selected()" i18n>🏷️</option>
    @for (t of templates(); track t.tag) {
      <option [value]="t.tag" [selected]="t.tag === selected()">{{ t.config?.submit }}</option>
    }
  </select>
}
